/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Simulate_OfflineInputs */

const en_mobile_dev_simulate_offline = /** @type {(inputs: Mobile_Dev_Simulate_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulate offline`)
};

const es_mobile_dev_simulate_offline = /** @type {(inputs: Mobile_Dev_Simulate_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simular sin conexión`)
};

/**
* | output |
* | --- |
* | "Simulate offline" |
*
* @param {Mobile_Dev_Simulate_OfflineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_simulate_offline = /** @type {((inputs?: Mobile_Dev_Simulate_OfflineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Simulate_OfflineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_simulate_offline(inputs)
	return en_mobile_dev_simulate_offline(inputs)
});